<template lang="pug">
v-container(v-if="funnelValues" fluid px-1 class="tw-w-full" )
    v-row(no-gutters)
        v-col(cols="12" class="funnel"  )
            div(class="tw-w-full animate__animated animate__fadeIn tw-z-40 tw-relative ")
                div(class="tw-absolute tw-w-full tw-h-full tw-z-10 tw-items-center tw-align-middle d-flex tw-items-center tw-justify-items-center tw-text-center ")
                    div(class=" tw-rounded-lg tw-relative tw-p-1 tw-w-24 tw-mx-auto tw-text-center tw-border-pink-accent-3")
                        span( class="font-weight-bold text-subtitle-1  tw-text-white") {{ funnelValues.qualify >= 0 ? this.$formatters.formatValue((funnelValues.qualify)) : '' }}
                div(class=" tw-z-0 tw-relative")
                    <svg viewBox="0 0 362 102" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Projects" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Projects-/-List-/-01---Sidebar" transform="translate(-100.000000, -187.000000)">
                                <g id="Sidebar" transform="translate(83.000000, -18.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                    <rect id="bg" x="1" y="0.5"></rect>
                                </g>
                                <polygon id="Triangle" stroke="#979797" fill="#D8D8D8" transform="translate(281.000000, 387.500000) scale(1, -1) translate(-281.000000, -387.500000) " points="200 188 362 188 461 587 101 587"></polygon>
                                <g id="Qualify" transform="translate(100.000000, 187.000000)">
                                    <rect id="Rectangle" x="0" y="0" ></rect>
                                    <path d="M361.354986,1.5 L335.612412,101.5 L26.3951105,101.5 L2.63273431,1.5 L361.354986,1.5 Z" id="Rectangle" stroke="#FF8989" fill="#F0737E"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
            div(class="tw-w-full animate__animated animate__fadeInDown  tw-pt-2 funnel-stage-two tw-relative tw-z-30")
                div(class="tw-absolute tw-w-full tw-h-full tw-z-10 tw-items-center tw-align-middle d-flex tw-items-center tw-justify-items-center tw-text-center ")
                    div(class=" tw-rounded-lg tw-relative tw-p-1 tw-w-24 tw-mx-auto tw-text-center tw-border-pink-accent-3 tw-mb-1")
                        span( class="font-weight-bold text-subtitle-1  tw-text-white ") {{ funnelValues.pitch >= 0 ? this.$formatters.formatValue((funnelValues.pitch)) : '' }}
                div(class=" tw-z-0 tw-relative")
                    <svg  viewBox="0 0 362 90" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Projects" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Projects-/-List-/-01---Sidebar" transform="translate(-100.000000, -299.000000)">
                                <g id="Sidebar" transform="translate(83.000000, -18.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                    <rect id="bg" x="1" y="0.5" ></rect>
                                </g>
                                <polygon id="Triangle" stroke="#979797" fill="#D8D8D8" transform="translate(281.000000, 387.500000) scale(1, -1) translate(-281.000000, -387.500000) " points="200 188 362 188 461 587 101 587"></polygon>
                                <g id="Pitch" transform="translate(100.000000, 299.000000)">
                                    <rect id="Rectangle" x="0" y="0"></rect>
                                    <path d="M332.807388,0.5 L311.26628,88.7363479 L51.0455678,88.7363479 L29.3143347,0.5 L332.807388,0.5 Z" id="Rectangle-Copy-4" stroke="#F2D298" fill="#F4BE5E"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
            div(class="tw-w-full animate__animated animate__fadeInDown  tw-pt-2 tw-z-20 funnel-stage-three tw-z-10 tw-relative")
                div(class="tw-absolute tw-w-full tw-h-full tw-z-10 tw-items-center tw-align-middle d-flex tw-items-center tw-justify-items-center tw-text-center ")
                    div(class=" tw-rounded-lg tw-relative tw-p-1 tw-w-24 tw-mx-auto tw-text-center tw-border-pink-accent-3 tw-mb-2")
                        span( class="font-weight-bold text-subtitle-1  tw-text-white") {{ funnelValues.negotiate >= 0 ? this.$formatters.formatValue((funnelValues.negotiate)) : '' }} 
                div(class=" tw-z-0 tw-relative ")
                    <svg class="tw-mx-auto " viewBox="0 0 362 94">
                        <g id="Projects" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Projects-/-List-/-01---Sidebar" transform="translate(-100.000000, -398.000000)">
                                <g id="Sidebar" transform="translate(83.000000, -18.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                    <rect id="bg" x="1" y="0.5"></rect>
                                </g>
                                <polygon id="Triangle" stroke="#979797" fill="#D8D8D8" transform="translate(281.000000, 387.500000) scale(1, -1) translate(-281.000000, -387.500000) " points="200 188 362 188 461 587 101 587"></polygon>
                                <g id="Negotiate" transform="translate(100.000000, 398.000000)">
                                    <rect id="Rectangle" x="0" y="0" ></rect>
                                    <path d="M308.615876,0.5 L285.264641,93.5 L77.0662728,93.5 L54.0800316,0.5 L308.615876,0.5 Z" id="Rectangle-Copy-5" stroke="#B5B7F8" fill="#9698D6"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
            div(class="tw-w-full animate__animated animate__fadeInDown tw-pt-2 tw-z-0 funnel-stage-four tw-z-0 tw-relative")
                div(class="tw-absolute tw-w-full tw-h-full tw-z-10 tw-items-center tw-align-middle d-flex tw-items-center tw-justify-items-center tw-text-center ")
                    div(class=" tw-rounded-lg tw-relative tw-p-1 tw-w-24 tw-mx-auto tw-text-center tw-border-pink-accent-3 tw-mb-2")
                        span( class="font-weight-bold text-subtitle-1  tw-text-white") {{ funnelValues.close >= 0 ? this.$formatters.formatValue((funnelValues.close)) : '' }}
                div(class=" tw-z-0 tw-relative ")
                    <svg class="tw-mx-auto" viewBox="-4 0 352 86" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Projects" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Projects-/-List-/-01---Sidebar" transform="translate(-110.000000, -501.000000)">
                                <g id="Sidebar" transform="translate(83.000000, -18.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                    <rect id="bg" x="1" y="0.5" ></rect>
                                </g>
                                <polygon id="Triangle" stroke="#979797" fill="#D8D8D8" transform="translate(281.000000, 387.500000) scale(1, -1) translate(-281.000000, -387.500000) " points="200 188 362 188 461 587 101 587"></polygon>
                                <g id="Close" transform="translate(110.000000, 501.000000)">
                                    <rect id="Rectangle" x="0" y="0"></rect>
                                    <path d="M271.873822,0.5 L251.605209,85.5 L90.3935849,85.5 L69.8574092,0.5 L271.873822,0.5 Z" id="Rectangle-Copy-6" stroke="#61DE99" fill="#59D18F"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
</template>
<script>
export default {
    data(){
        return{}
    },
    computed:{
        funnelValues(){
            return this.$store.getters['opportunities/funnel_values']
        }
    }
}
</script>

<style lang="stylus" scoped>
.funnel-stage-two
    animation-delay: .6s

.funnel-stage-three
    animation-delay: 1s

.funnel-stage-four
    animation-delay: 1.4s
</style>